import { useLayoutEffect, useRef, useState, type CSSProperties } from "react";
import { useNavigate, useParams } from "react-router";
import { ContractingDetailContent } from "@/components/contractings/ContractingDetailContent";

export default function ContractingDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const contractingId = Number(id);

  // Quien entra por un enlace directo (el correo del resumen) no tiene página
  // anterior en la app: volver atrás lo sacaría de Licitigo.
  const goBack = () =>
    window.history.state?.idx > 0 ? navigate(-1) : navigate("/dashboard");

  // La tarjeta llena lo que queda de pantalla y el único scroll es el de su
  // contenido. Se mide dónde empieza porque el alto del header cambia con el ancho.
  const cardRef = useRef<HTMLDivElement>(null);
  const [cardTop, setCardTop] = useState(0);
  useLayoutEffect(() => {
    const measure = () => {
      const card = cardRef.current;
      if (card) setCardTop(card.getBoundingClientRect().top + window.scrollY);
    };
    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, []);

  return (
    <div className="mx-auto w-full max-w-7xl px-4 pb-4 pt-4 md:px-6 md:pt-6">
      {/* Bajo la tarjeta quedan el pb-4 de esta página y, en móvil, el pb-20 que
          AppLayout reserva para la tab bar: 6rem en móvil y 1rem en escritorio. */}
      <div
        ref={cardRef}
        style={{ "--card-top": `${cardTop}px` } as CSSProperties}
        className="h-[calc(100dvh-var(--card-top)-6rem)] overflow-hidden rounded-2xl border bg-card lg:h-[calc(100dvh-var(--card-top)-1rem)]"
      >
        {Number.isFinite(contractingId) ? (
          <ContractingDetailContent
            contractingId={contractingId}
            onBack={goBack}
          />
        ) : (
          <p className="text-sm text-muted-foreground">Licitación no válida.</p>
        )}
      </div>
    </div>
  );
}
